var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InsightsFilters',{key:_vm.refreshKey,staticClass:"mb-4",on:{"filtersApplied":_vm.refreshSummary,"refresh":_vm.refreshFilters}}),_c('InsightsSummary',{attrs:{"loading":_vm.loading,"wcLoading":_vm.wcLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }